import React from 'react';

import styled from '@emotion/styled';

import { Tenants } from '../../icons';
import { ResultGoToItem, ResultItemBase } from './ResultItem';

const SmallDetails = styled.div`
  font-size: 12px;
`;

export const TenantCell: ResultItemBase<{}> = ({ hit, components }) => {
  return (
    <a href={ResultGoToItem(hit)} className="aa-ItemLink">
      <div className="aa-ItemContent">
        <Tenants />
        <div className="aa-ItemTitle">
          <components.Highlight hit={hit} attribute="name" />
          <SmallDetails>
            <components.Highlight hit={hit} attribute="email" />
          </SmallDetails>
          <SmallDetails>
            <components.Highlight hit={hit} attribute="phoneNumber" />
          </SmallDetails>
        </div>
      </div>
    </a>
  );
};
